<agr-form-dialog
  [formGroup]="formGroup"
  (confirm)="save()"
  (alt)="alt()"
  (cancel)="cancel()"
  [data]="data"
>
  <div class="flex--column">
    <div
      class="spacing--padding-half-all text--bold heading-wrapper spacing--padding-top spacing--padding-half-bottom"
    >
      {{ 'settings.dosator-setting.general' | translate }}
      <div class="border-top--gray3 horizontal-line spacing--margin-half-left"></div>
    </div>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'settings.dosator-setting.name' | translate }}</mat-label>
      <input
        matInput
        placeholder="{{ 'settings.dosator-setting.name' | translate }}"
        formControlName="name"
        data-test="dosator-setting-item__name"
      />
      <mat-error
        *ngIf="
          !!formGroup &&
          !!formGroup.controls.name.errors &&
          formGroup.controls.name.errors.duplicateDosatorSettingName
        "
      >
        {{ 'settings.dosator-setting.invalid.duplicate-name' | translate }}
      </mat-error>
      <mat-error
        *ngIf="
          !!formGroup && !!formGroup.controls.name.errors && formGroup.controls.name.errors.required
        "
      >
        {{ 'settings.dosator-setting.invalid.name' | translate }}
      </mat-error>
    </mat-form-field>

    <div
      class="spacing--padding-half-all text--bold heading-wrapper spacing--padding-top spacing--padding-half-bottom"
    >
      {{ 'settings.dosator-setting.products' | translate }}
      <div class="border-top--gray3 horizontal-line spacing--margin-half-left"></div>
    </div>

    <div class="flex--column" *ngIf="isMobile$ | async">
      <mat-form-field class="flex__child--auto spacing--margin-top">
        <mat-select
          [hideSingleSelectionIndicator]="true"
          placeholder="{{ 'settings.dosator-setting.product-select' | translate }}"
          [(value)]="selectedTabIndex"
          data-test="dosator-setting-detail__product-select"
        >
          <mat-option *ngFor="let tab of this.tabs; let i = index" [value]="i"
            >Dosator Setting {{ i + 1 }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>

    <div class="">
      <mat-tab-group
        animationDuration="0"
        [(selectedIndex)]="selectedTabIndex"
        color="accent"
        [ngClass]="dosatorProductTabsClass"
        [mat-stretch-tabs]="false"
      >
        <mat-tab *ngFor="let tab of this.tabs; let i = index" class="">
          <ng-template mat-tab-label>Dosator Setting {{ i + 1 }}</ng-template>
          <app-dosator-setting-product-item
            [dosatorProductFormGroup]="productFormGroups[i]"
            [dosatorProduct]="dosatorSetting.products[i]"
            [products]="products$ | async"
            [index]="i"
            (deleteDosatorProduct)="delete($event)"
            [canDelete]="canDeleteProduct"
            [isMobile]="isMobile$ | async"
          >
          </app-dosator-setting-product-item>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</agr-form-dialog>
